import { generateUtilityClass, generateUtilityClasses } from '@mui/material';

export function getUtilityClass(slot: string): string {
  return generateUtilityClass('PopoverContentFooter', slot);
}

export const popoverContentFooterClasses = generateUtilityClasses('PopoverContentFooter', [
  'root',
  'buttons',
]);

export type PopoverContentFooterClasses = typeof popoverContentFooterClasses;
